<style lang="scss" scoped>
.attachments {
  &__list {
    @apply box-border flex m-0 mb-2 w-full #{!important};
  }

  &__file {
    @apply flex p-3 rounded-md m-0 justify-start flex-row;
    background-color: #ecf0f1;
  }

  &__icon {
    @apply mx-2 rounded-none p-0  #{!important};
    @apply flex items-center justify-center;
    background: none;
    flex: none;

    img {
      height: 30px;
      padding: 0;
      width: auto;
    }
  }

  &__title {
    @apply text-sm box-border m-0 p-0 pr-2 mr-2 border-r border-gray-400 #{!important};
    @apply self-stretch;
    @apply flex flex-col items-start justify-center;
  }

  &__date {
    @apply block #{!important};
    font-size: 0.65rem;
  }

  &__download {
    @apply text-xs leading-none uppercase mt-1;
    color: var(--blue-alt);
    font-weight: bold;
  }
}

</style>

<template>
  <article class="medical_record">
    <div class="modal active">
      <div
        class="modal-overlay"
        @click="$emit('closed', true)"
      />

      <div class="modal-container">
        <header class="modal-header">
          <h2 class="mt-2 text-lg text-semibold">
            Download de prontuário
          </h2>
        </header>

        <!-- prontuario geral -->
        <template v-if="selectedModal === 'fullRecord'">
          <section class="modal-body">
            <div
              v-if="fullMedicalRecord"
              class="border-b border-rounded border-gray-300 mb-2 pb-2"
            >
              <p class="text-base mb-2">Prontuário disponível</p>

              <ul class="attachments__list">
                <li class="attachments__file">
                  <div class="attachments__icon">
                    <img src="@/assets/img/pdf.png" />
                  </div>

                  <p class="attachments__title">
                    <strong class="!text-semibold">
                      Prontuário completo
                    </strong>

                    <small class="attachments__date">
                      Solicitado em {{ fullMedicalRecord.created_at | TO_DATE }}
                    </small>
                  </p>

                  <button
                    :disabled="generatingPdf"
                    class="flex flex-col justify-center text-blue"
                    @click="downloadRecord(fullMedicalRecord)"
                  >
                    <dr-icon
                      name="cloudDownload"
                      fill="blue"
                      class="w-6 m-auto"
                    />

                    <small class="attachments__download">
                      Download
                    </small>
                  </button>
                </li>
              </ul>
            </div>

            <div class="border-b  border-gray-300 mb-2 pb-2">
              <p class="text-base text-semibold mb-2">
                Solicitar prontuário
              </p>

              <p class="mt-0 mb-2">
                Ao baixar o prontuário com o histórico completo de consultas,
                qualquer arquivo baixado anteriormente será substituído pelo
                novo arquivo. Deseja prosseguir com o download?
              </p>
            </div>
          </section>

          <footer class="modal-footer flex-space_between mb-2">
            <button
              @click="$emit('closed', true)"
              class="btn btn-transparent !h-7 !p-0 !px-5 !flex !items-center !justify-center !text-sm"
            >
              Cancelar
            </button>

            <dr-submit
              :sending="sending"
              text="Solicitar download"
              class="btn btn-primary !h-7 !p-0 !px-5 !flex !items-center !justify-center !text-sm"
              @click="submit()"
            />
          </footer>
        </template>

        <!-- prontuario por consulta -->
        <template v-else>
          <section class="modal-body !pb-0">
            <header>
              <p>Selecione a seguir o período desejado para consulta</p>

              <div class="flex-space_between flex-wrap">
                <dr-datepicker
                  type="calendar"
                  :placeholder="'Data inicial'"
                  class="!flex btn btn-transparent !px-4 !h-8 !w-auto !rounded-full"
                  @change="period.start = $event"
                />

                <dr-datepicker
                  type="calendar"
                  :placeholder="'Data final'"
                  class="!flex btn btn-transparent !px-4 !h-8 !w-auto !rounded-full"
                  @change="period.end = $event"
                />

                <button
                  class="btn btn-primary !p-0 !px-5 !flex !items-center !justify-center !text-sm"
                  @click="fetch"
                >
                  <i class="icon leading-none m-0 p-0 icon-search mr-2" />
                  Buscar
                </button>
              </div>

              <small
                :class="appointmentsTotal === null ? 'invisible' : ''"
                class="inline-block w-full font-bold text-right h-5 py-2"
              >
                <template v-if="appointmentsTotal > 0">
                  {{ appointmentsTotal }} prontuários encontrados
                </template>

                <template v-else>
                  Nenhum prontuário encontrado no período
                </template>
              </small>
            </header>

            <div class="appointment_results w-10/12 overflow-auto mx-auto mobile:w-full">
              <transition-group name="fade" mode="out-in">
                <div
                  v-if="!searching && Object.keys(appointments).length === 0"
                  :key="'text'"
                  class="appointment_list h-full flex justify-center items-center"
                >
                  <p class="">
                    Escolha um intervalo de datas e clique em buscar.
                  </p>
                </div>

                <div
                  v-if="searching"
                  :key="'loader'"
                  class="appointment_list h-full flex justify-center items-center"
                >
                  <dr-loader size="lg" />
                </div>

                <ul
                  v-if="Object.keys(appointments).length > 0"
                  :key="'list'"
                >
                  <li
                    v-for="(appointmentDay, $index) in appointments"
                    :key="'appd'+$index"
                    class="flex w-full flex-col"
                  >
                    <div>
                      <div class="bg-green inline rounded-full
                        text-white text-center
                        pl-2 pr-1 font-semibold mr-1
                        flex-inline items-center justify-center
                      ">
                        {{ $index.replace(/-[0-9][0-9]-[0-9][0-9]/, '') }}
                      </div>

                      <strong class="text-green">
                        {{ MONTHS[$moment($index).format('M')].substr(0,3) }}
                        {{ $moment($index).format('D') }}
                      </strong>
                    </div>

                    <fieldset class="flex flex-wrap mt-2">
                      <label
                        v-for="(appointmentHour, $index2) of appointmentDay"
                        :key="'ck'+$index2"
                        class="!mr-4 mb-1 whitespace-no-wrap form-radio"
                      >
                        <input
                          :name="'selectedAppointment'"
                          :value="appointmentHour.id"
                          :class="selectedAppointment === appointmentHour.id ? 'checked' : ''"
                          type="checkbox"
                          @click.prevent="
                            selectedAppointment = selectedAppointment === appointmentHour.id
                              ? null
                              : appointmentHour.id
                          "
                        />

                        <i class="form-icon" />
                        {{ appointmentHour.time }} {{ appointmentHour.type }}
                      </label>
                    </fieldset>
                  </li>
                </ul>
              </transition-group>
            </div>
          </section>

          <footer class="modal-footer flex-space_between mb-2 mt-4 border-t flex-wrap">
            <button
              class="btn btn-transparent mb-4 !p-0 !px-5 !flex !items-center !justify-center !text-sm"
              @click="$emit('closed', true)"
            >
              Cancelar
            </button>

            <dr-submit
              :disabled="!selectedAppointment"
              :sending="sending"
              text="Solicitar download"
              class="btn btn-primary !p-0 !px-5 !flex !items-center !justify-center !text-sm"
              @click="submit('specific')"
            />
          </footer>
        </template>
      </div>
    </div>
  </article>
</template>

<script>
import DrDatepicker from '@/components/form/datepicker'
import DrSubmit from '@/components/form/submit'
import Axios from 'axios'

export default {
  name: 'ModalMedicalRecord',

  components: {
    DrDatepicker,
    DrSubmit
  },

  props: {
    selectedModal: {
      type: String,
      required: true
    },

    fullMedicalRecord: {
      type: Object,
      default: () => null
    },

    patient: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      period: {
        start: null,
        end: null
      },
      generatingPdf: false,
      sending: false,
      searching: false,
      appointments: {},
      appointmentsTotal: null,
      selectedAppointment: null,
      totalSelectedAppointments: 0
    }
  },

  watch: {
    selectedModal () {
      this.period = {
        start: null,
        end: null
      }
    }
  },

  computed: {
    buildQuery () {
      const initialDate = this.$moment(this.period.start).format('YYYY-MM-DD')
      const finalDate = this.$moment(this.period.end).format('YYYY-MM-DD')

      return `filterGreatherEqual[a.appointmentStart]=${
        initialDate
      } 00:00:00&filterLessEqual[a.appointmentStart]=${
        finalDate
      } 23:59:59&itensPerPage=all`
    }
  },

  mounted () {
    this.period.start = null
    this.period.end = null
    this.appointments = {}
    this.appointmentsTotal = null
    this.selectedAppointment = null
    this.totalSelectedAppointments = 0
  },

  methods: {
    clickRadio (index, v) {
      this.$set(
        this.selectedAppointments,
        index,
        this.selectedAppointments[index] === v ? null : v
      )
      this.$forceUpdate()
    },

    downloadRecord (record) {
      if (!record) {
        return null
      }

      this.fn_SHOW_PROGRESS()
      this.generatingPdf = true

      const url = `${this.API_URL}/s3/file/medical_record_download/${record.uuid}/uuid`

      Axios.get(url, {
        headers: this.$store.getters.getAuthHeader.headers,
        responseType: 'blob'
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/pdf' })
        const href = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = href
        link.download = `prontuario_${this.patient.name.replace(' ', '-')}_${this.$moment(record.created_at).format('DD-MM-YYYY')}.pdf`
        link.target = '_blank'
        link.click()
      })
        .catch((err) => this.fn_HANDLE_ERROR(err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.generatingPdf = false
        })
    },

    fetch () {
      this.appointments = {}
      this.appointmentsTotal = null
      this.totalSelectedAppointments = 0

      this.searching = true
      this.fn_SHOW_PROGRESS()

      let type = this.$route.params.patientType === 'specialPatient'
        ? 'special_patient'
        : 'patient'

      const userQuery = this.$route.params.patientType === 'specialPatient'
        ? 'sp.id'
        : 'u.id'

      let url = this.fn_IS_SECRETARY()
        ? `/secretary/doctor/${
          this.$route.params.doctorId
        }/${
          type
        }/${
          this.$route.params.id
        }?${
          this.buildQuery
        }&order[a.appointmentStart]=DESC&filterAnd[a.status]=REALIZADO`
        : `/${
          this.fn_GET_PARENT_ROUTE(this.$route)
        }/agenda?filterAnd[${
          userQuery
        }]=${
          this.$route.params.id
        }&${
          this.buildQuery
        }&order[a.appointmentStart]=DESC&filterAnd[a.status]=REALIZADO`

      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          let i = 0

          for (const appointment of res.data.data) {
            const momentObj = this.$moment(appointment.agendaAppointmentStart)

            if (!this.appointments[momentObj.format('YYYY-MM-DD')]) {
              this.appointments[momentObj.format('YYYY-MM-DD')] = []
            }

            this.appointments[momentObj.format('YYYY-MM-DD')].push({
              id: '' + appointment.agendaId,
              type: appointment.medicalConsultationType.toLowerCase(),
              time: momentObj.format('HH:mm')
            })

            i++
          }

          this.appointmentsTotal = i
        })
        .finally(() => {
          this.searching = false
          this.fn_HIDE_PROGRESS()
        })
    },

    submit (all = 'all') {
      this.sending = true
      let patientType = this.$route.params.patientType === 'specialPatient'
        ? 'specialPatient'
        : 'user'

      let data = {}

      if (all === 'all') {
        data.type = 'ALL'
      } else {
        data.type = 'SPECIFIC'
        data.agenda = this.selectedAppointment
      }

      data[patientType] = this.$route.params.id

      this.$http
        .post(
          '/doctor/medical_record_download',
          { create: data },
          this.$store.getters.getAuthHeader
        )
        .then(() => {
          this.$store.dispatch('setModalAlert', {
            title: 'Prontuário solicitado com sucesso!',
            body: `Estamos preparando o arquivo do prontuário.
              Dentro de alguns minutos você receberá um e-mail
              informando que arquivo está pronto para você
              efetuar o download.`,
            size: 'md',
            active: true
          })

          this.$emit('closed', true)
        })
        .catch((err) => {
          const [msg] = this.findErrorMessage(err.errors)

          if (/existe um pedido/gi.test(msg)) {
            const newErr = {
              errors: [`Você já possui um pedido de download, com esses parâmetros,
                em andamento. Por favor, aguarde a notificação por e-mail para
                baixar o conteúdo solicitado.`]
            }

            this.fn_HANDLE_ERROR(newErr)
            return
          }

          this.fn_HANDLE_ERROR(err)
        })
        .finally(() => {
          this.sending = false
        })
    },

    findErrorMessage (object) {
      let errorMessage = null
      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }
      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }
      return errorMessage
    }
  }
}
</script>
